import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToImdb = {
  [titleId: string]: WpsTypes.atv.wps.ImdbFragmentModelProps | undefined
}

export const reducer = createMergeReducer(t => t.imdb, {} as TitleIdToImdb)
